export const environment = {
  production: '#{Front.production}#',
  tokenSAS: '#{Front.tokenSAS}#', 
  storageAccountName: '#{Front.storageAccountName}#', 
  authConfig: 
  { 
    clientId: '#{Front.clientId}#', 
    tenant: '#{Front.tenant}#' 
  }, 
    request: {
    iataConnectionType: '#{Front.iataConnectionType}#', 
    noIataConnectionType: '#{Front.noIataConnectionType}#', 
    ndcConnectionType: '#{Front.ndcConnectionType}#', 
    syncConnectionType: '#{Front.syncConnectionType}#', 
    bspArcConnectionType: '#{Front.bspArcConnectionType}#', 
    supervisorRoleARD: '#{Front.supervisorRoleARD}#', 
    iataAgencyType: '#{Front.iataAgencyType}#', 
    noIataAgencyType: '#{Front.noIataAgencyType}#', 
    comercialContact: '#{Front.comercialContact}#', 
    financialContact: '#{Front.financialContact}#', 
    redirect: '#{Front.redirect}#', 
    maxSignaturesIataParameter: '#{Front.maxSignaturesIataParameter}#',
    maxSignaturesNoIataParameter: '#{Front.maxSignaturesNoIataParameter}#', 
    idSabreColombia: '#{Front.idSabreColombia}#', 
    idAmadeusColombia: '#{Front.idAmadeusColombia}#',
    idTravelPortColombia:'#{Front.idTravelPortColombia}',
    countryOthers: '#{Front.countryOthers}#', 
    countryColombia: '#{Front.countryColombia}#', 
    paco: '#{Front.paco}#', 
    compareOldDate: '#{Front.compareOldDate}#', 
    countryUnitedStates: '#{Front.countryUnitedStates}#', 
    countryUnitedKingdom: '#{Front.countryUnitedKingdom}#',
    countryIsrael: '#{Front.countryIsrael}#', 
    countryGermany: '#{Front.countryGermany}#'
  },
  showBanner: '#{Front.showBanner}#',
  secretWord: '#{Front.secretWord}#',
  consultasFrecuentesEs: '#{Front.consultasFrecuentesEs}#',
  consultasFrecuentesEn: '#{Front.consultasFrecuentesEn}#',
  consultasFrecuentesPt: '#{Front.consultasFrecuentesPt}#'
};
